class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    var elem = this;
    var flkty = new Flickity(elem, {
      // options
      pageDots: false,
      prevNextButtons: false,
      autoPlay: 3000,
      wrapAround: true
    });
  }
}
customElements.define("announcement-bar", AnnouncementBar);